import React from "react";
import { bindActionCreators } from "redux";
import * as modalActions from "../../redux/actions/modalActions";
import { useSelector, useDispatch } from "react-redux";
import PrefferedLanguage from "../../components/Settings/PrefferedLanguage";
import PropTypes from "prop-types";

const PrefferedLanguageModel = (props, context) => {
  const dispatch = useDispatch();

  const modalAction = bindActionCreators(modalActions, dispatch);

  const closeRemoveModal = () => {
    modalAction.closeRemoveModal();
  };

  return (
    <PrefferedLanguage
      context={context}
      closeRemoveModal={closeRemoveModal}
      {...props}
    />
  );
};

PrefferedLanguageModel.contextTypes = {
  t: PropTypes.func.isRequired,
};
export default PrefferedLanguageModel;
